import { render, staticRenderFns } from "./AmazeUpload.vue?vue&type=template&id=e7f246fa&scoped=true"
import script from "./AmazeUpload.vue?vue&type=script&lang=js"
export * from "./AmazeUpload.vue?vue&type=script&lang=js"
import style0 from "./AmazeUpload.vue?vue&type=style&index=0&id=e7f246fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f246fa",
  null
  
)

export default component.exports